import { css } from "lit"

export const responsiveStyles = css`
  /* Responsive design */
  @media (min-width: 768px) {
    .container {
      max-width: 640px;
    }
  }

  @media (min-width: 1024px) {
    .container {
      max-width: 1024px;
    }
  }
`
